import { Injectable } from "@angular/core";
import { Observable, catchError, map, switchMap, tap, throwError, timeout } from 'rxjs';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment as ENV } from '../../../environments/environment';
import { lastValueFrom } from 'rxjs';
import { CarnetModel } from "../../models/carnet";
import { URL_MAP } from "../../shared/urlMap";

@Injectable({
  providedIn: 'root'
})
export class PoblacionService {
  HOST = ENV.HOST;
  API = URL_MAP.API;
  constructor(
    private httpClient: HttpClient,
  ) { }
  
  public loadGeneralParameters(option: number): Observable<any> {  
    var jsonParametros = {
      "prm_opcion": option.toString()
    };       
    const httpOptions = {
      headers: new HttpHeaders({
        'Accept': "*/*"
      })
    };
    return this.httpClient.post(`${this.HOST}${this.API.GETPOBLACIONVALORES}`, jsonParametros, httpOptions);
  }

  public consultPoblacionEdadCartera(json: any): Observable<any> {
    var jsonParametros = {
      "prm_docu_asesor": json.identificationAsesor,
      "prm_tipo_asesor": json.typeAsesor, 
      "prm_cuota_vencida": json.cuota
    };
    const httpOptions = {
      headers: new HttpHeaders({
        'Accept': "*/*"
      })
    };
    return this.httpClient.post(`${this.HOST}${this.API.GETPOBLACIONEDADCARTERA}`, jsonParametros, httpOptions);   
  }

  public consultPoblacionActivos(json: any): Observable<any> {  
    var jsonParametros = {
      "prm_docu_asesor": json.identificationAsesor,
      "prm_tipo_asesor": json.typeAsesor, 
      "prm_genero": json.genero,
      "prm_parentesco": json.parentesco,
      "prm_programa": json.programa,
      "prm_edad": json.edad
    };
    const httpOptions = {
      headers: new HttpHeaders({
        'Accept': "*/*"
      })
    };
    return this.httpClient.post(`${this.HOST}${this.API.GETPOBLACIONUSUARIOSACTIVOS}`, jsonParametros, httpOptions);      
  }

  public consultPoblacionRetirados(json: any): Observable<any> { 
    var jsonParametros = {
      "prm_docu_asesor": json.identificationAsesor,
      "prm_tipo_asesor": json.typeAsesor
    };
    const httpOptions = {
      headers: new HttpHeaders({
        'Accept': "*/*"
      })
    };
    return this.httpClient.post(`${this.HOST}${this.API.GETPOBLACIONUSUARIOSRETIRADOS}`, jsonParametros, httpOptions);   
  }

  public getMisUsuariosMiPoblacion(json: any): Observable<any> {
    var jsonParametros = { 
      "prm_docu_tipo": json.typeDocument,
      "prm_docu_nro": json.identification.toString(),
      "prm_docu_asesor": json.identificationAsesor,
      "prm_tipo_asesor": json.typeAsesor,
      "prm_contratos": json.contrato
    };
    const httpOptions = {
      headers: new HttpHeaders({
        'Accept': "*/*"
      })
    };
    return this.httpClient.post(`${this.HOST}${this.API.GETPOBLACIONMISUSUARIOS}`, jsonParametros, httpOptions);   
  }

  public getDetalleUsuarioMiPoblacion(json: any): Observable<any> {
    var jsonParametros = {
      "prm_docu_tipo": json.typeDocument,
      "prm_docu_nro": json.identification.toString(),
      "prm_contrato": json.contrato
    };
    const httpOptions = {
      headers: new HttpHeaders({
        'Accept': "*/*"
      })
    };
    return this.httpClient.post(`${this.HOST}${this.API.GETPOBLACIONDETALLEUSUARIO}`, jsonParametros, httpOptions);   
  }

  async getCarnetImagen(codigo: string): Promise<any> {
    try {     
      var jsonParametros = { 
        "prm_programa": codigo
      };
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept': "*/*" ,  
          'x-skip-tracking': 'true'      
        })
      };  
      const respuesta = await lastValueFrom(
        this.httpClient.post(`${this.HOST}${this.API.GETCARNET}`, jsonParametros, httpOptions).pipe(timeout(6000))
      );
      return respuesta;
    } catch (error) {
      console.error('Error al obtener la imagen carnet:', error);
      throw error;
    }
  }

  async getCarnetData(json: CarnetModel): Promise<any> {
    try {
      var jsonParametros = { 
        "prm_docu_tipo": json.typeDocument,
        "prm_docu_nro": json.identification.toString(),
        "prm_docu_asesor": json.identificationAsesor,
        "prm_tipo_asesor": json.typeAsesor
      };
      const httpOptions = {
        headers: new HttpHeaders({
          'Accept': "*/*",
          'x-skip-tracking': 'true' 
        })
      };  
      const respuesta = await lastValueFrom(
        this.httpClient.post(`${this.HOST}${this.API.GETCARNETAFILIADOS}`, jsonParametros, httpOptions)
      );  
      return respuesta;
    } catch (error) {
      console.error('Error al obtener información carnet:', error);
      throw error;
    }
  }
  
  public getDetalleAnexosUsuarioMiPoblacion(json: any): Observable<any> {
    var jsonParametros = {
      "contrato": json.contrato,
      "inte": json.integrante
    };
    const httpOptions = {
      headers: new HttpHeaders({
        'Accept': "*/*"
      })
    };
    return this.httpClient.post(`${this.HOST}${this.API.GETPOBLACIONDETALLEANEXOUSUARIO}`, jsonParametros, httpOptions);
  }
}